import React, { useState } from 'react';
import { AccordionDetails, AccordionSummary, Accordion } from '@mui/material';
import { navigationEvent } from 'services/dataLayerService';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from 'components/Core/Button';
import HyperLink from 'components/Core/HyperLink';
import WebsiteImage from 'components/WebsiteImage';
import { ButtonsContainer, NavItem, NavItemsContainer } from '../styles';

const AccordionMenu = ({ groups, selectedMenu, subNavigationElement, setMobileMenuOpened }) => {
  const [expanded, setExpanded] = useState(groups?.[0] ? `${selectedMenu}-${groups?.[0]}` : '');
  const viewAllCtas = {
    'Key Features': '/features',
    Trades: '/industries',
    Resources: '/toolbox',
  };
  return groups?.map((groupLabel, index) => {
    return (
      <NavItemsContainer key={`child-nav-${selectedMenu}-${index}`}>
        <div className="w-full relative">
          <Accordion
            expanded={expanded === `${selectedMenu}-${groupLabel}`}
            classes={{
              root: '!relative !shadow-none border border-solid border-1 border-b border-grey-2 border-t-0 border-l-0 border-r-0 rounded-none',
            }}
          >
            <AccordionSummary
              classes={{
                root: 'flex !mb-0 px-[30px] py-0',
                expandIconWrapper: 'flex !justify-start !my-0 [&>svg]:fill-[#17191C]',
                content: 'my-[20px]',
              }}
              onClick={() => {
                setExpanded(
                  expanded === `${selectedMenu}-${groupLabel}`
                    ? ''
                    : `${selectedMenu}-${groupLabel}`,
                );
                navigationEvent(groupLabel, null, `${selectedMenu}-${groupLabel}-dropdown`);
              }}
              expandIcon={<ExpandMoreIcon />}
            >
              <p className="m-0">
                <b>{groupLabel}</b>
              </p>
            </AccordionSummary>
            <AccordionDetails
              classes={{
                root: 'flex flex-col gap-5 p-[10px_30px_30px_30px]',
              }}
            >
              {subNavigationElement?.map((navEle) => {
                const { label, url, icon } = navEle || {};
                return (
                  navEle.group?.group === groupLabel && (
                    <HyperLink
                      id="HEADER"
                      href={url}
                      onClick={() => {
                        navigationEvent(label, url);
                        setMobileMenuOpened(false);
                      }}
                    >
                      <NavItem className="!p-0">
                        <WebsiteImage
                          {...icon}
                          loading="eager"
                          widthMobile="24px"
                          widthDesktop="24px"
                        />
                        <p className="nav-item-label font-p">
                          <b>{label}</b>
                        </p>
                      </NavItem>
                    </HyperLink>
                  )
                );
              })}
              {viewAllCtas[groupLabel] && (
                <ButtonsContainer className="!p-0">
                  <Button
                    to={viewAllCtas[groupLabel]}
                    type="transparent - black border"
                    className="header-menu-cta"
                    onClick={() => {
                      navigationEvent('View All', viewAllCtas[groupLabel]);
                      setMobileMenuOpened(false);
                    }}
                  >
                    <p className="font-sm">
                      <b>View All</b>
                    </p>
                  </Button>
                </ButtonsContainer>
              )}
            </AccordionDetails>
          </Accordion>
        </div>
      </NavItemsContainer>
    );
  });
};
export default AccordionMenu;
